import { render, staticRenderFns } from "./AmazonImportManager.vue?vue&type=template&id=52129926&lang=pug"
import script from "./AmazonImportManager.vue?vue&type=script&lang=ts"
export * from "./AmazonImportManager.vue?vue&type=script&lang=ts"
import style0 from "./AmazonImportManager.vue?vue&type=style&index=0&id=52129926&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports